module.exports = __webpack_public_path__ + "img/Frame_16.ad54234e.png";